import { Link } from "react-router-dom";
import { useCompanyCompare } from "../context/CompanyCompareContext";

export default function CompanyCompareBar() {
  const { companyCompareList, removeCompanyCompare } = useCompanyCompare();

  if (companyCompareList.length === 0) return null;

  const compareUrl = `/compare-companies?companyIds=${companyCompareList.map((c) => encodeURIComponent(c.companyId)).join(",")}&companyNames=${encodeURIComponent(companyCompareList.map((c) => c.companyName).join("|"))}`;

  return (
    <div
      className="print:hidden fixed bottom-0 left-0 right-0 z-50 bg-navy-900/95 backdrop-blur-md border-t border-teal-500/20 px-4 py-3"
      ref={(el) => {
        if (el) {
          document.documentElement.style.setProperty("--company-bar-height", `${el.offsetHeight}px`);
        } else {
          document.documentElement.style.setProperty("--company-bar-height", "0px");
        }
      }}
    >
      <div className="max-w-3xl mx-auto flex items-center gap-3 flex-wrap">
        <span className="text-white/40 text-xs shrink-0">Comparing companies:</span>
        {companyCompareList.map((c) => (
          <div key={c.companyId} className="flex items-center gap-1.5 bg-navy-800 border border-teal-500/20 rounded-lg px-3 py-1.5">
            <span className="text-white/70 text-xs truncate max-w-32">{c.companyName}</span>
            <button
              onClick={() => removeCompanyCompare(c.companyId)}
              className="text-white/30 hover:text-white/70 text-xs ml-1 shrink-0"
            >
              ×
            </button>
          </div>
        ))}
        {companyCompareList.length < 3 && (
          <span className="text-white/20 text-xs">+ add {3 - companyCompareList.length} more</span>
        )}
        <div className="ml-auto flex items-center gap-2">
          {companyCompareList.length >= 2 ? (
            <Link to={compareUrl} className="btn-primary text-sm px-4 py-2">
              Compare {companyCompareList.length} {companyCompareList.length === 1 ? "company" : "companies"} →
            </Link>
          ) : (
            <span className="text-xs px-4 py-2 rounded-lg border border-white/10 text-white/25 cursor-not-allowed">
              Select {2 - companyCompareList.length} more to compare
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
